module.exports = __webpack_public_path__ + "img/icon-org.0eeea484.svg";